import { px, rect, cRect, mPx, CENTER } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

export const hull_wedge: Hull = {
  id: 'hull_wedge',
  name: 'Wedge',
  drawBody: (ctx, p) => {
    const profile = [[25,1],[26,1],[27,2],[28,2],[29,3],[30,3],[31,4],[32,4],[33,5],[34,6],[35,7],[36,7],[37,7],[38,7],[39,6],[40,5]];
    profile.forEach(([y, hw]) => cRect(ctx, y, hw * 2, 1, p.primary));
    profile.forEach(([y, hw]) => { px(ctx, CENTER - hw, y, p.light); px(ctx, CENTER + hw - 1, y, p.shadow); });
    cRect(ctx, 38, 14, 1, p.shadow); cRect(ctx, 39, 12, 1, p.shadow); cRect(ctx, 40, 10, 1, p.dark);
    cRect(ctx, 28, 2, 8, p.accent);
  },
  mounts: {
    [SLOT.COCKPIT]:    { anchor: { x: 32, y: 31 }, cap: (ctx, p) => { mPx(ctx, 2, 30, p.dark); mPx(ctx, 2, 31, p.dark); mPx(ctx, 2, 32, p.dark); cRect(ctx, 34, 4, 1, p.dark); } },
    [SLOT.WING_L]:     { anchor: { x: 24, y: 36 }, cap: (ctx, p) => { rect(ctx, 23, 35, 4, 3, p.shadow); rect(ctx, 23, 35, 4, 1, p.dark); } },
    [SLOT.WING_R]:     { anchor: { x: 39, y: 36 }, cap: (ctx, p) => { rect(ctx, 37, 35, 4, 3, p.shadow); rect(ctx, 37, 35, 4, 1, p.dark); } },
    [SLOT.ENGINE_L]:   { anchor: { x: 28, y: 41 }, cap: (ctx, p) => { rect(ctx, 27, 40, 3, 2, p.shadow); rect(ctx, 27, 40, 3, 1, p.dark); } },
    [SLOT.ENGINE_R]:   { anchor: { x: 36, y: 41 }, cap: (ctx, p) => { rect(ctx, 34, 40, 3, 2, p.shadow); rect(ctx, 34, 40, 3, 1, p.dark); } },
    [SLOT.WEAPON_TOP]: { anchor: { x: 32, y: 26 }, base: (ctx, p) => { cRect(ctx, 27, 2, 2, p.metalDark); cRect(ctx, 27, 2, 1, p.metal); } },
    [SLOT.NOSE]:       { anchor: { x: 32, y: 25 } },
  },
};
